import { Component, Inject, OnInit } from '@angular/core';

import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { Paginacao } from '@app/models/util/paginacao';
import { ModalConfirmarComponent } from '@app/components/modal-confirmar/modal-confirmar.component';

import { TipoDeAcao } from '@app/models/tipo-de-acao.model';
import { TipoDeAcaoService } from '@app/services/tipo-de-acao.service';
import { ToastrService } from 'ngx-toastr';


@Component({
  selector: 'app-tipo-de-acao-lista',
  templateUrl: './tipo-de-acao-lista.component.html'
})
export class TipoDeAcaoListaComponent implements OnInit {

  bsModalRef: BsModalRef;
  filtroDescricao = '';
  paginacao: Paginacao = new Paginacao();
  tiposDeAcoes: TipoDeAcao[];

  constructor(
    @Inject(ToastrService) public toastr: ToastrService,
    private tipoDeAcaoService: TipoDeAcaoService,
    private modalService: BsModalService) { }

  ngOnInit() {
    this.obterTodos(this.filtroDescricao, 1);
  }

  pesquisar() {
    this.obterTodos(this.filtroDescricao, 1);
    this.paginacao.paginaAtual = 1;
  }

  obterTodos(descricao: string, pagina: number) {
    this.tipoDeAcaoService.obterLista(descricao, pagina).toPromise().then(data => {
      this.tiposDeAcoes = data.Dados,
        this.paginacao.totalDeItens = data.Total;
    },
      erro => {
        // this.loading = false;
        this.toastr.warning('Realize a pesquisa novamente.');
      });
  }

  deletar(tipoDeAcao: TipoDeAcao) {
    this.bsModalRef = this.modalService.show(ModalConfirmarComponent);
    this.bsModalRef.content.mensagem = 'Deseja realmente excluir o tipo de ação: ' + tipoDeAcao.Descricao + '?';
    this.bsModalRef.content.confirmar = () => {
      this.tipoDeAcaoService.deletar(tipoDeAcao.Id).toPromise().then(() => {
        this.obterTodos(this.filtroDescricao, 1);
        this.paginacao.paginaAtual = 1;
      });
    };
  }

  public pageChanged(event: any): void {
    this.obterTodos(this.filtroDescricao, event.page);
  }
}
